<template lang="pug">
#wrap_sub
  .sub_right
    .content_desc
      #s31.sub
        .in
          h2.s_tit
            span Nano Brewery
          p.ss_tit INTHEKEG's Smart Brewery Platform can also be used as a nano brewery system model in which various types of craft beer can be produced even in a limited space without the help of professional brewers.
        .s31_a
          .cont
            .top
              .in
                .lt(data-aos='fade-right')
                  h3 A nano brewery in Ansan
                  .img
                    img(src='https://office--file.s3.ap-northeast-2.amazonaws.com/img/s31_lt.jpg' alt='')
                .rg(data-aos='fade-right' data-aos-delay='200')
                  h3 A nano brewery in Ulsan
                  .img
                    img(src='https://office--file.s3.ap-northeast-2.amazonaws.com/img/s31_rg.jpg' alt='')
            .bot
              .in
                .lt(data-aos='fade-right')
                  h3 The unique features of INTHEKEG-based nano breweries
                .rg
                  ul
                    li(data-aos='fade-right' data-aos-delay='200')
                      h4 Capable of producing craft beer 
                        span.bold with the minimum space required (Nano Brewery) 
                        span.fz → This type of brewery can be built in a small space of less than 355 square ft (about 33 ㎡)
                    li(data-aos='fade-right' data-aos-delay='400')
                      h4 
                        span.bold Capable of producing customized beers 
                        | using local specialties
                    li(data-aos='fade-right' data-aos-delay='600')
                      h4
                        span.bold Can be also used as a hands-on activity workshop 
                        | for beer brewing
        .s31_b.sub
          .in
            .tit
              h3(data-aos='fade-up') NANO BREWERY
              p(data-aos='fade-up' data-aos-delay='200')
                | You only need the INTHEKEG system to ferment and age your beer. This means that you can easily build and have your own nano brewery 
                span.bold with a total capacity of less than 200 liters. 
                | Such nano breweries have already been built in Ansan and Ulsan, in which four wort-making devices 
                span.bold with a capacity of 200 liters are installed in a space of about 252 square ft (about 23 m2) for craft beer production.
            .cont
              .img(data-aos='fade-up')
                img(src='https://office--file.s3.ap-northeast-2.amazonaws.com/img/s31b01.jpg' alt='')
              .img(data-aos='fade-up' data-aos-delay='200')
                img(src='https://office--file.s3.ap-northeast-2.amazonaws.com/img/s31b02.jpg' alt='')
              .img(data-aos='fade-up' data-aos-delay='300')
                img(src='https://office--file.s3.ap-northeast-2.amazonaws.com/img/s31b03.jpg' alt='')
              .img(data-aos='fade-up' data-aos-delay='400')
                img(src='https://office--file.s3.ap-northeast-2.amazonaws.com/img/s31b04.jpg' alt='')
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {},
};
</script>
<style scope>
@import '../../assets/css/en_common_fir.css';
@import '../../assets/css/en_common_sec.css';
@import '../../assets/css/en_common_thi.css';
.sub_right .content_desc #s31.sub {
  padding-top: 120px;
}
</style>
